import { render, staticRenderFns } from "./MenuMecanica.vue?vue&type=template&id=ed4a06f6&scoped=true&"
import script from "./MenuMecanica.vue?vue&type=script&lang=js&"
export * from "./MenuMecanica.vue?vue&type=script&lang=js&"
import style0 from "./MenuMecanica.vue?vue&type=style&index=0&id=ed4a06f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4a06f6",
  null
  
)

export default component.exports